// frontend/src/lib/metaPixel.js
// Client-side Meta Pixel loader. Pixel ID comes from REACT_APP_META_PIXEL_ID.
// When that env var is unset (local/dev), every export no-ops so no events fire.

function getPixelId() {
  return process.env.REACT_APP_META_PIXEL_ID;
}

// Installs the standard fbq stub + async loader script exactly once.
function loadFbq() {
  if (window.fbq) return;
  const n = (window.fbq = function () {
    n.callMethod
      ? n.callMethod.apply(n, arguments)
      : n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  if (s && s.parentNode) s.parentNode.insertBefore(t, s);
  else document.head.appendChild(t);
}

// Customer estimate links (/e/<token>) carry a private token in the path, and
// the pixel's PageView sends the full URL to Meta. Never load it there.
function isPrivateCustomerPage() {
  return window.location.pathname.startsWith('/e/');
}

export function initMetaPixel() {
  const pixelId = getPixelId();
  if (!pixelId) return; // no-op when unset
  if (isPrivateCustomerPage()) return;
  loadFbq();
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
}

export function trackEvent(name, params) {
  if (!getPixelId() || !window.fbq) return; // no-op when unset or uninitialized
  window.fbq('track', name, params);
}
